<template>
  <div class="modal"
       id="modal-assign-subtest-attempt"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ translate('modals.assign.title') + ' #' + subtestAttempt.id }}
          </h5>
        </div>

        <div class="modal-body">
          <form role="form">
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right" for="reviewer">
                {{ translate('modals.assign.form.reviewer') }}
              </label>

              <div class="col-md-6">
                <multiselect v-model="reviewer"
                             id="reviewer"
                             :class="{'is-invalid': assignSubtestAttemptForm.errors.has('reviewer_id')}"
                             :deselect-label="translate('modals.assign.form.required')"
                             :select-label="translate('modals.assign.form.select')"
                             :placeholder="translate('modals.assign.form.select_reviewer')"
                             open-direction="bottom"
                             label="name"
                             track-by="id"
                             :options="reviewers"
                             :searchable="true"
                             :allow-empty="false">
                </multiselect>

                <span class="invalid-feedback"
                      v-if="assignSubtestAttemptForm.errors.has('reviewer_id')">
                                        @{{ assignSubtestAttemptForm.errors.get('reviewer_id') }}
                                    </span>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal">
            {{ translate('modals.assign.close') }}
          </button>
          <button type="button"
                  class="btn btn-success"
                  @click.prevent="assignSubtestAttempt"
                  :disabled="assignSubtestAttemptForm.busy || !reviewer">
            {{ translate('modals.assign.submit') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  props: ['subtestAttempt', 'reviewers'],

  components: {
    Multiselect
  },

  /**
   * The component's data.
   */
  data () {
    return {
      assignSubtestAttemptForm: new AppForm({
        reviewer_id: null
      }),
      reviewer: null,
    };
  },

  methods: {
    /**
     * Assign the Subtest Attempt to Reviewer.
     */
    assignSubtestAttempt () {
      let self = this;
      self.assignSubtestAttemptForm.reviewer_id = self.reviewer.id;

      App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/assign', this.assignSubtestAttemptForm)
        .then(() => {
          $('#modal-assign-subtest-attempt').modal('hide');

          self.$parent.$emit('getSubtestAttempt', self.subtestAttempt.id);
        });
    },
  }
};
</script>
